export const gdpr = {
  routes: [
    {
      path: "/gdpr/data-breach",
      component: () => import("../organization-data-breach-view"),
    },
    {
      path: "/gdpr/data-breach/create",
      component: () => import("../organization-data-breach-detail-view"),
    },
    {
      path: "/gdpr/data-breach-detail/:id",
      component: () => import("../organization-data-breach-detail-view"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/data-breach",
      component: () => import("../organization-data-breach-view"),
    },
    {
      path: "/kvkk/data-breach/create",
      component: () => import("../organization-data-breach-detail-view"),
    },
    {
      path: "/kvkk/data-breach-detail/:id",
      component: () => import("../organization-data-breach-detail-view"),
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/data-breach",
      component: () => import("../organization-data-breach-view"),
    },
    {
      path: "/ddo/data-breach/create",
      component: () => import("../organization-data-breach-detail-view"),
    },
    {
      path: "/ddo/data-breach-detail/:id",
      component: () => import("../organization-data-breach-detail-view"),
    },
  ],
};
